import Component from "../classes/Component";
import Swiper, { Navigation, Scrollbar } from "swiper";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/scrollbar";

// init Swiper:

export default class MarquesSliderCustomers extends Component {
  constructor() {
    super({
      element: "[data-components-slider-customers]",
      elements: {},
    });

    this.init();
  }
  init() {
    if (this.element) {
      this.initSlider();
    }
  }

  initSlider() {
    this.sliders = new Swiper(this.element.querySelector('.swiper'), {
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: false,
      grabCursor: true,
      freeMode: true,
      watchOverflow: true,
      modules: [Navigation, Scrollbar],
      scrollbar: {
        el: this.element.querySelector('.sliders-nav__scrollbar'),
        draggable: true,
      },
      navigation: {
        nextEl: this.element.querySelector('.sliders-nav__button-next'),
        prevEl: this.element.querySelector('.sliders-nav__button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 40,
        },
      },
    });
    const count = this.sliders.slides.length;

    if(count <5) {
      this.element.querySelector('.sliders-nav__option').classList.add('disabled');
      this.element.querySelector('.swiper-wrapper').classList.add('justify-center');
    }
  }
}
